import { Box, Button, IconButton, Typography } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { Container, styled } from "@mui/material";
import React, { useContext, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import { RetailSettingContext } from "../../services/retail/setting/retailSettingContext";
import { firebaseAndKvaLog } from "../../services/analytics/analytic.service";
import { sendSetting } from "../../services/retail/setting/retailSettingService";
import { toastError, toastSuccess } from "../../services/toast/toast";
import { useRouter } from "../../utils/hooks/useRouter";
import { Redirect } from "../../utils/Redirect";

interface IPropsAppBarOrder {
  textButton?: string;
  titleAppBar?: string;
  iconClose?: React.ReactNode;
  iconBack?: React.ReactNode;
  onClickBack?: () => void;
  onClickClose?: any;
}

const StyledOrderConfirmAppBar = styled("div")({
  position: "sticky",
  top: 0,
  zIndex: 3,
});

const BorderLinearProgress = styled(LinearProgress)(({}) => ({
  height: 6,
  borderRadius: "2px",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgb(162, 198, 255)",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "2px",
    backgroundColor: "#0B6BFF",
  },
}));

function LinearProgressWithLabel(props: any) {
  return (
    <Box>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontSize: 32,
          "@media (max-width: 600px)": {
            fontStyle: "normal",
            fontFamily: "Inter, sans-serif",
            lineHeight: "28px",
            fontSize: "20px",
            marginBottom: "16px",
          },
        }}
        mb={4}
      >{`${Math.round(props.value)}%`}</Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <BorderLinearProgress variant="determinate" {...props} />
        </Box>
      </Box>
    </Box>
  );
}

function AppBarCustom({
  textButton,
  titleAppBar,
  iconClose,
  iconBack,
  onClickBack,
  onClickClose,
}: IPropsAppBarOrder) {
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(50);
  const router = useRouter();

  const handleCloseBackdrop = () => {
    // setOpen(false);
  };

  const {
    amountSale,
    productStore,
    priceSale,
    pricePromotion,
    synced,
    setSynced,
    setInitSetting,
    setRollback,
  } = useContext(RetailSettingContext);

  const processing = (toast: any, callback: any) => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          toast();
          setOpen(false);
          clearInterval(timer);
          callback && callback();
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);
  };

  const handleToggleBackdrop = async () => {
    setOpen(!open);
    const platform = router.query.platform;
    firebaseAndKvaLog("kiotonline", "mk_setting_save");
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }
    try {
      const settingPayload = {
        is_stocked: productStore,
        price_formula_id: priceSale,
        promotion_formula_id: pricePromotion,
        amount_sale: amountSale,
        platform,
      };
      const settingRes = await sendSetting(settingPayload);
      if (settingRes.status === 200) {
        const toast = () => toastSuccess("Lưu thay đổi thành công");
        processing(toast, () => {
          setSynced && setSynced(true);
          setInitSetting &&
            setInitSetting({
              product_store: productStore,
              price_sale: priceSale,
              price_promotion: pricePromotion,
              amount_sale: "tonkho_dathang",
            });
        });
      }
    } catch (err) {
      const toast = () =>
        toastError(
          `Vui lòng kiểm tra kết nội mạng hoặc quay trở lại sau để tiếp tục thay đổi “Đồng bộ hóa”..`,
          "Không thành công"
        );
      processing(toast, () => {
        setSynced && setSynced(false);
        setRollback && setRollback(Date.now());
      });
    }
  };

  const goBack = () => {
    onClickClose && onClickClose();
  };

  return (
    <StyledOrderConfirmAppBar>
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#fff",
          color: "#323741",
          py: "16px !important",
          px: "16px !important",
          boxShadow:
            "0px 4px 24px rgba(0, 0, 0, 0.05), 0px 1px 5px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          {iconBack ? (
            <IconButton
              sx={{ padding: "4px", mr: "16px" }}
              onClick={onClickBack}
            >
              {iconBack}
            </IconButton>
          ) : null}
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              flexGrow: 1,
              textAlign: "left",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "32px",
              fontFamily: "Inter,sans-serif",
            }}
            component="div"
          >
            {titleAppBar}
          </Typography>

          {iconClose ? (
            <IconButton sx={{ padding: "4px" }} onClick={goBack}>
              {iconClose}
            </IconButton>
          ) : null}
        </Box>
        {textButton ? (
          <Button
            variant="contained"
            disabled={synced ? true : false}
            sx={{
              boxShadow: "none",
              padding: "6px 16px",
              borderRadius: "12px",
              background: "#0070F4",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter,sans-serif",
              "&:hover,&:focus": {
                backgroundColor: "#004881",
                boxShadow: "none",
              },
              "&:disabled": {
                backgroundColor: "#F8F8F8",
                border: "none",
                color: "#919AA4",
              },
            }}
            onClick={handleToggleBackdrop}
          >
            {textButton}
          </Button>
        ) : null}
      </Container>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleCloseBackdrop}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box mt={4} sx={{ width: 300 }}>
            <Box sx={{ width: "100%" }}>
              <LinearProgressWithLabel variant="determinate" value={progress} />
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: 18,
                  "@media (max-width: 600px)": {
                    fontStyle: "normal",
                    fontFamily: "Inter, sans-serif",
                    lineHeight: "24px",
                    fontSize: "16px",
                  },
                }}
                mt={2}
              >
                Đang lưu thay đổi ...
              </Typography>
            </Box>
          </Box>
        </Box>
      </Backdrop>
    </StyledOrderConfirmAppBar>
  );
}

export default AppBarCustom;
